"use client";

import React from 'react';
import { Icon } from '@iconify/react';
import { techCategories } from '@/lib/tech-categories';

interface TechSectionProps {
    title: string;
    t: (key: string) => string;
}

const TechSection: React.FC<TechSectionProps> = ({ title, t }) => {
    return (
        <section className="my-24">
            <h2 className="text-3xl font-bold text-center mb-12">{title}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div>
                    <h3 className="text-xl font-semibold mb-4">{t('Backend')}</h3>
                    <div className="flex flex-wrap gap-4">
                        {techCategories.backend.map((tech, index) => (
                            <div key={index} className="flex items-center gap-2 text-white/70">
                                <Icon icon={tech.icon} className="text-2xl" />
                                <span>{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-semibold mb-4">{t('Frontend')}</h3>
                    <div className="flex flex-wrap gap-4">
                        {techCategories.frontend.map((tech, index) => (
                            <div key={index} className="flex items-center gap-2 text-white/70">
                                <Icon icon={tech.icon} className="text-2xl" />
                                <span>{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-semibold mb-4">{t('Mobile')}</h3>
                    <div className="flex flex-wrap gap-4">
                        {techCategories.mobile.map((tech, index) => (
                            <div key={index} className="flex items-center gap-2 text-white/70">
                                <Icon icon={tech.icon} className="text-2xl" />
                                <span>{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-semibold mb-4">{t('Cloud')}</h3>
                    <div className="flex flex-wrap gap-4">
                        {techCategories.cloud.map((tech, index) => (
                            <div key={index} className="flex items-center gap-2 text-white/70">
                                <Icon icon={tech.icon} className="text-2xl" />
                                <span>{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TechSection;
